import { render, staticRenderFns } from "./CurrentHealthInsurance.vue?vue&type=template&id=0c483093&scoped=true&"
import script from "./CurrentHealthInsurance.vue?vue&type=script&lang=js&"
export * from "./CurrentHealthInsurance.vue?vue&type=script&lang=js&"
import style0 from "./CurrentHealthInsurance.vue?vue&type=style&index=0&id=0c483093&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c483093",
  null
  
)

export default component.exports